import { ProjetTemplate } from '../templates/projet.tpl';

export const ProjetDocument = {
    id: 'Bilan',
    template: ProjetTemplate,
    model: {
        title: 'Bilan',
        description: 'Quantité des produits pétroliers enlevées des dépôts par camion et par marketeUr',
        pageOrientation: 'landscape',
        columnsHeader:[],
        columnsSize:[],
        query: (params: any) => {
            return[]
            ;
        },
        params: (fluid:string) => [],
        sums:(fluid:string) => []
    }
};